<div class="full-page-container">
  <div class="full-page-padding">
    <div class="container">
    <div class="datasources-main" [hidden]="loading">
      <!-- <div class="main-header">
        <div class="main-header-title">
          <span class="main-title">Notifications</span>
        </div>
      </div> -->
      <div class=" notifications-page-outer-wrapper">
        <div class="main-header">
        <div class="row justify-content-between align-items-center">
          <div class="col-auto"><h1 *ngIf="!hideTitle">Notifications</h1></div>
          <div class="d-flex col-auto items-center">
              <mat-form-field class="notification-type custom-select m-r-35 tooltip hover-tooltip tooltip-sm background-none">
                  <mat-select [(value)]="notificationType" (selectionChange)="changeNotificationType(notificationType)">
                    <mat-option *ngFor="let notification of notificationOptions" [value]="notification.type">
                      {{notification.displayName}}
                    </mat-option>
                  </mat-select>
                  <div class="tooltip-section fade-in">
                      <div  class="tooltip-body" >
                          Change notification type
                      </div>
                  </div>
                </mat-form-field>
            <!-- <span (click)="clearAllNotifications()">Clear All</span> (click)="clearAllNotifications()" -->
            <button mat-stroked-button color="primary" (click)="clearAllNotifications()" class="clear-button tooltip hover-tooltip tooltip-sm val-txt" >Delete All
                <div class="tooltip-section fade-in">
                    <div  class="tooltip-body" >
                        Delete All
                    </div>
                </div>
              </button>
          </div>
        </div>
      </div>
        <!-- <div class="notifications-page-header" style="display: none;">
          <div class="notifications-page-header-text">
            <div class="notifications-page-main-text custom-"><h1 class="m-t-32">Notifications</h1></div>
          </div>
          <div class="notifications-page-header-filters">


          </div>
          <div class="notification-page-clear-all" >
              <mat-form-field class="custom-select m-r-35 tooltip hover-tooltip tooltip-sm">
                  <mat-select [(value)]="notificationType" (selectionChange)="changeNotificationType(notificationType)">
                    <mat-option *ngFor="let notification of notificationOptions" [value]="notification.type">
                      {{notification.displayName}}g
                    </mat-option>
                  </mat-select>
                  <div class="tooltip-section fade-in">
                      <div  class="tooltip-body" >
                          Change notification type
                      </div>
                  </div>
                </mat-form-field>
            <button mat-button color="primary" (click)="clearAllNotifications()" class="clear-button tooltip hover-tooltip tooltip-sm" >Clear All
                <div class="tooltip-section fade-in">
                    <div  class="tooltip-body" >
                        Clear All
                    </div>
                </div>
              </button>
          </div>
        </div> -->
        <div class="notifications-page-all-block">
            <!-- <span class="loading-dots" [hidden]="notificationReturned">Loading...</span> -->

          <div class="label-03 c-f-notables" [hidden]="!notificationReturned || filteredNotifications.length">Currently there are no notifications.</div>
              <div [hidden]="!notificationReturned || !filteredNotifications.length" *ngFor="let notification of filteredNotifications | paginate: { itemsPerPage: paginationInfo.pageSize, currentPage: paginationInfo.pageIndex, totalItems: paginationInfo.totalItems }" >
                <!--*ngIf="ifTitle(notification, i)"-->

                <div class="light-small ml-2 pb-2 title-head" *ngIf="ifTitle(notification, i)">{{notification.title}}</div>

                <div class="alert alert-light alert-{{getNotificationType(notification.type)}} border-left-{{getNotificationType(notification.type)}} mb-2">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="alert-left">
                            <div class="alert-body word-wrap">
                                <div class="alert-icon">
                                    <i class="fa {{getIconType(notification.type)}}"></i>
                                </div>
                                <div class="alert-message">
                                    {{notification.message}}
                                  </div>
                            </div>
                        </div>
                        <div class="alert-right">
                            <span class="light-small mr-2">
                                {{notification.minsBack}}
                            </span>
                            <!--(click)="close(notification, 'Yes')"-->
                            <button (click)="deleteNotification(notification)" mat-icon-button class="icon-btn-sm btn-danger tooltip hover-tooltip tooltip-sm" >
                                <i class="far fa-trash-alt"></i>
                                <div class="tooltip-section fade-in">
                                  <div  class="tooltip-body" >
                                      Delete
                                  </div>
                              </div>
                              </button>
                        </div>
                    </div>
                </div>



              </div>
              <!-- <div class="center-align" [hidden]="!notificationReturned || !filteredNotifications.length" >

                    <button mat-stroked-button color="primary" class="float-right mb-2 button-wrap pre-sty"
                    (click)="getPreviousRecord()">

                    More
                  </button>

              </div> -->
              <!-- <mat-paginator [length]="paginationInfo.totalItems" *ngIf="!(!notificationReturned || !filteredNotifications.length)"
              [pageSize]="paginationInfo.pageSize"
              [pageSizeOptions]="[5, 10, 25, 100]"
              (page)="pageEvent = getServerData($event)"
              aria-label="Select page">
</mat-paginator> -->
                <ng-container *ngIf="!(!notificationReturned || !filteredNotifications.length)">
                    <!-- <ul>
                        <li *ngFor="let item of filteredNotifications | paginate: { itemsPerPage: paginationInfo.pageSize, currentPage: paginationInfo.pageIndex }"> ... </li>
                      </ul> -->
                      <div class="d-flex justify-content-center notification-pagination align-items-center">
                          <div>
                              <p class="mb-0 notification-pagination-details">
                                  Showing {{(manualPageIndex) * paginationInfo.pageSize + 1}} to {{(manualPageIndex) * paginationInfo.pageSize + filteredNotifications.length}} of {{paginationInfo.totalItems}} entries
                              </p>
                          </div>
                          <pagination-controls [previousLabel]="'Prev'" class="my-pagination" (pageChange)="pageChange($event)"></pagination-controls>
                      </div>
                </ng-container>

              <div *ngIf="!notificationReturned">

                <div class="ph-item">
                    <div class="d-flex">
                        <div class="mr-2">
                            <div class="ph-picture ph-h-25 ph-w-25p rounded text-box-loader"></div>
                        </div>

                    </div>

                </div>
                <div class="ph-item">
                    <div class="d-flex">

                        <div>
                            <div class="ph-picture ph-h-15 text-box-loader-desc" ></div>

                        </div>
                    </div>
                </div>
                <div class="ph-item">
                        <div class="d-flex">
                            <div class="mr-2">
                                <div class="ph-picture ph-h-25 ph-w-25p rounded text-box-loader"></div>
                            </div>

                        </div>

                    </div>
                    <div class="ph-item">
                        <div class="d-flex">

                            <div>
                                <div class="ph-picture ph-h-15 text-box-loader-desc" ></div>

                            </div>
                        </div>
                    </div>
                    <div class="ph-item">
                            <div class="d-flex">
                                <div class="mr-2">
                                    <div class="ph-picture ph-h-25 ph-w-25p rounded text-box-loader"></div>
                                </div>

                            </div>

                        </div>
                        <div class="ph-item">
                            <div class="d-flex">

                                <div>
                                    <div class="ph-picture ph-h-15 text-box-loader-desc" ></div>

                                </div>
                            </div>
                        </div>

                    </div>

            </div>
      </div>
    </div>
  </div>
  </div>
</div>
